import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LoadingService } from 'app/core/services/loading.service';
import { AsyncPipe } from '@angular/common';

/**
 * Barra de progresso global (topo da tela) — substitui o NProgress. Indeterminada, animada via CSS,
 * visível enquanto houver requisição em andamento (LoadingService). Montada uma vez no app.component.
 */
@Component({
    selector: 'oab-progress-bar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './progress-bar.component.html',
    styleUrl: './progress-bar.component.scss',
    imports: [AsyncPipe],
})
export class OabProgressBarComponent {
  private loading = inject(LoadingService);

  readonly active$ = this.loading.active$;
}
